// extracted by mini-css-extract-plugin
module.exports = {"modal":"RecoverPasswordSuccess_modal__nx8bT","ant-modal-content":"RecoverPasswordSuccess_ant-modal-content__3Ud9m"};